// extracted by mini-css-extract-plugin
export default {"reg_wrong":"styles_reg_wrong__9KDUg","reg_wrong__img":"styles_reg_wrong__img__IvAjC","reg_wrong__invalid_link":"styles_reg_wrong__invalid_link__VGHtF"};